import chart from './chart'
import chartsData from './chartsData'
import chartsDuplicate from './chartsDuplicate'
import chartsShare from './chartsShare'

const charts = {
  chart,
  chartsData,
  chartsDuplicate,
  chartsShare,
}

export default charts
